import React from 'react';
import classnames from 'classnames';
import { checkString, checkArray } from '../helpers/global'

const Combi = props => {

  const {data} = props;
  console.log(data);
  let img_src = "";
  let img_alt = "";
  let focal_point = "";
  let combiStyle = {};
  if (checkArray(data.image_data)){
    img_src = data.image_data.toString();
  }
  img_alt = data.image_alt;

  if (checkArray(data.focal_point)){
    focal_point = data.focal_point;
     combiStyle = {
      objectPosition: focal_point[0] + "%" + " " + focal_point[1] + "%"
    }
  }

  let tag = "";

  if (checkString(data.slot_tag)){
    tag = data.slot_tag;
  } else  {
    tag = data.template_name;
  }



  return (

    <div className="grid-item " >
      <a href={data.url}
        className={"slot " + `${data.template_name}` + "-slot"}>

        <svg className="slot-bg" xmlns="http://www.w3.org/2000/svg" width="140" height="120" viewBox="0 0 140 120" fill="none">
          <rect x="99" y="120" width="21" height="20" transform="rotate(-90 99 120)" fill="white"/>
          <rect x="119" y="120" width="21" height="21" transform="rotate(-90 119 120)" fill="white"/>
          <rect opacity="0.6" x="78" y="120" width="21" height="21" transform="rotate(-90 78 120)" fill="white"/>
          <rect x="40" y="120" width="21" height="20" transform="rotate(-90 40 120)" fill="white"/>
          <rect x="60" y="120" width="21" height="19" transform="rotate(-90 60 120)" fill="white"/>
          <rect x="99.375" y="99.2871" width="19.8571" height="19.875" transform="rotate(-90 99.375 99.2871)" fill="white"/>
          <rect x="119" y="99" width="20" height="21" transform="rotate(-90 119 99)" fill="white"/>
          <rect x="79.5" y="99.2871" width="19.8571" height="19.875" transform="rotate(-90 79.5 99.2871)" fill="white"/>
          <rect opacity="0.2" x="39.75" y="99.2871" width="19.8571" height="19.875" transform="rotate(-90 39.75 99.2871)" fill="white"/>
          <rect x="59.625" y="99.2871" width="19.8571" height="19.875" transform="rotate(-90 59.625 99.2871)" fill="white"/>
          <rect opacity="0.75" x="99.375" y="79.4297" width="19.8571" height="19.875" transform="rotate(-90 99.375 79.4297)" fill="white"/>
          <rect opacity="0.75" x="119" y="79" width="19" height="21" transform="rotate(-90 119 79)" fill="white"/>
          <rect opacity="0.5" x="79.5" y="79.4297" width="19.8571" height="19.875" transform="rotate(-90 79.5 79.4297)" fill="white"/>
          <rect opacity="0.2" x="99.375" y="59.5723" width="19.8571" height="19.875" transform="rotate(-90 99.375 59.5723)" fill="white"/>
          <rect opacity="0.75" x="119" y="60" width="20" height="21" transform="rotate(-90 119 60)" fill="white"/>
          <rect opacity="0.5" x="99.375" y="39.7148" width="19.8571" height="19.875" transform="rotate(-90 99.375 39.7148)" fill="white"/>
          <rect x="119" y="40" width="20" height="21" transform="rotate(-90 119 40)" fill="white"/>
          <rect opacity="0.5" x="119" y="20" width="20" height="21" transform="rotate(-90 119 20)" fill="white"/>
          <rect opacity="0.2" x="79.5" y="59.5723" width="19.8571" height="19.875" transform="rotate(-90 79.5 59.5723)" fill="white"/>
          <rect opacity="0.2" x="59.625" y="79.4297" width="19.8571" height="19.875" transform="rotate(-90 59.625 79.4297)" fill="white"/>
          <rect opacity="0.5" x="20" y="120" width="21" height="20" transform="rotate(-90 20 120)" fill="white"/>
          <rect opacity="0.2" x="0.125" y="119.145" width="19.8571" height="19.875" transform="rotate(-90 0.125 119.145)" fill="white"/>

        </svg>
       {checkString(img_src) &&

         <div className="slot-image">
           <div className="image-container">

            <img loading="lazy" srcset={img_src}  alt={img_alt} style={combiStyle} />
           </div>
         </div>
       }
        <div className="slot-content">

          <div className="slot-title h4" dangerouslySetInnerHTML={{__html: data.title}}/>
          <div class="slot-details">
            {checkString(data.member_slot_tag) &&
              <div class="slot-member">
                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                  <rect x="2" y="4.5" width="8.5" height="7" rx="0.75" stroke="#00273D"/>
                <path d="M8.5 4.5V2.75C8.5 1.50736 7.49264 0.5 6.25 0.5V0.5C5.00736 0.5 4 1.50736 4 2.75L4 4.5" stroke="#00273D"/>
                </svg>
                <span>{data.member_slot_tag}</span>
              </div>
            }
            {checkString(data.slot_tag) &&
              <div className="slot-type">{data.slot_tag}</div>
            }
          </div>


          {checkString(data.text) &&
            <p className="slot-text" dangerouslySetInnerHTML={{__html: data.text}} />
          }
          <div className="slot-dates full">

            {checkString(data.date_formatted) &&
              <div class="slot-date full">
                <div class="slot-date-label">Published</div>
                <div className="info-value" dangerouslySetInnerHTML={{__html: data.date_formatted}} />
              </div>
            }


          </div>
          <div className="button primary_square small"><span>{data.link_title}</span></div>




        </div>
      </a>
    </div>
  )
}

export default Combi;
